var paginationI18n = {
  currentPage: 'Page %{pageNumber} (Current Page)',
  goto: 'Go to page %{pageNumber}',
  next: 'Next',
  pageSizeInformation: 'of %{total}',
  paginationNavigation: 'Pagination Navigation',
  previous: 'Previous',
  selectPageSize: 'Select page size'
};
export default paginationI18n;